/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { AbstractFinderDialogComponent } from '@gh/common-internal-shared';
import { observableBasedSlicedDataSource, SlicedDataSource } from '@gh/core-data';
import { TranslationService } from '@gh/core-mls';
import { WaitingService } from '@gh/core-ui';
import {
  getTaxRateId,
  TaxRate,
  TaxRateFinderBusinessService,
  TaxRateFinderDialogConfig,
} from '../../resources';
import { XeroTaxRateFinderDialogGridDefinition } from './tax-rate-finder-dialog-grid-definition.service';

@Component({
  standalone: false,
  selector: 'gh-xero-tax-rate-finder-dialog',
  templateUrl: 'tax-rate-finder-dialog.component.html',
  styleUrls: ['tax-rate-finder-dialog.component.scss'],
  providers: [XeroTaxRateFinderDialogGridDefinition],
})
export class TaxRateFinderDialogComponent
  extends AbstractFinderDialogComponent<TaxRateFinderDialogConfig, TaxRate>
  implements OnInit {

  getId = getTaxRateId;
  defaultTitle = this.translations.get('lbl_xero_tax_rates');

  constructor(
    public gridDefinition: XeroTaxRateFinderDialogGridDefinition,
    private translations: TranslationService,
    private waitingService: WaitingService,
    private dialogRef: MatDialogRef<any>,
    private businessService: TaxRateFinderBusinessService,
  ) {
    super(dialogRef);
  }

  protected buildDataSource(): SlicedDataSource<TaxRate> {
    return observableBasedSlicedDataSource(this.businessService.findAll(this.input.tmpCredentials));
  }
}
